export const capabilities = [
  "Cloud",
  "Cyber Security",
  "Data and Artificial Intelligence",
  "Enterprise Applications and Automation",
  "IoT and Digital Engineering",
  "Managed Services",
  "Marketing & Experience",
  "Quality Engineering",
  "Strategy",
  "Sustainability",
  "Talent & Learning",
  "Technology Consulting",
];

export const capabilitiesNav = [
  {
    name: "Cloud",
    link: "/services/cloud",
    category: "Capabilities",
  },
  {
    name: "Cyber Security",
    link: "/services/cybersecurity",
  },
  {
    name: "AI Agents & Automation",
    link: "/services/analytics-ai-automation",
  },
  {
    name: "Forward Deployed Engineering",
    link: "/services/forward-deployed-engineering",
  },
  {
    name: "Enterprise Applications and Automation",
    link: "/services/enterprise-applications",
  },
  {
    name: "IoT and Digital Engineering",
    link: "/services/iot-and-digital-eng",
  },
  {
    name: "Managed Services",
    link: "/services/managed-services",
  },
  {
    name: "Quality Engineering",
    link: "/services/quality-engineering",
  },
  {
    name: "Strategy",
    link: "/services/strategy",
  },
  {
    name: "Technology Consulting",
    link: "/services/technology-consulting",
  },
  {
    name: "Tech Stack Audit",
    link: "/services/tech-stack-audit",
  },
];

export const industriesNav = [
  {
    name: "Banking",
    link: "/industry/banking",
    category: "Industries",
  },
  {
    name: "Insurance",
    link: "/industry/insurance",
  },
  {
    name: "Life Sciences",
    link: "/industry/life-sciences",
  },
  {
    name: "Retail",
    link: "/industry/retail",
  },
  {
    name: "Supply Chain",
    link: "/industry/supply-chain",
  },
];

export const badgeMapper = badge => {
  if (badge === "case-study") return "Success Story";
  return "Insight";
};

export const careerData = [
  {
    point: "1. Solve awesome problems",
    pointText: "Whether it is technology, strategy, sales, or marketing, interesting problems find us",
    desc: "From increasing operational efficiency by 400x, to designign the most scalable cloud architecture, to rewriting algorithms to process faster in real time, all the way to discovering the right business strategies for the customer, we do it all.",
    linkText: "Success Stories",
    link: "/blog/success-stories",
    img: "/career/career - technlogies.webp",
  },
  {
    point: "2. Work across industries",
    pointText: "Our universe is truly parallel. Which one would you like?",
    desc: " Be it D2C retail, supply chain, pharma and life sciences, fintech and more, you get to expose yourself to an unparalleled diversity of business problems.",
    linkText: "",
    link: "",
    img: "/career/career - diverse industries.webp",
  },
  {
    point: "3. Have a little fun while you do it",
    pointText: "Road trips, anyone?",
    desc: "Enjoy not just the grind but also the unwinds. From unplanned road-trips to goofy ittle things, we’ve got the spirit to make every day at work ridiculously entertaining.",
    linkText: "",
    link: "",
    img: "/career/career - fun.webp",
  },
];

export const careerLookingFor = [
  {
    title: "You must love solving problems",
    desc: "Problems excite no one. Solutions excite everyone. But only a few are willing to put their backs into finding a solution while the rest give up. You are not 'the rest.'",
  },
  {
    title: "Technology is just another toolkit in your bag",
    desc: "Can you only solve a problem if its within your skills. What do you do when needed to learn something new and deliver quickly?",
  },
  {
    title: "You must understand the value of helping your mates",
    desc: " Remember a leading runner slowing down to help his fallen competitor? Would you slow down if you knew your team mate really needed your help?",
  },
];

export const categoriesData = [
  {
    title: "Design",
    desc: "Change is the only constant. Reinvent your business with the right strategy and technology implementations.",
  },
  {
    title: "Build",
    desc: "Technology is often the key differentiator. Get the technology you need to lead the competition.",
  },
  {
    title: "Improve",
    desc: "Right quality and mature operations hold the key to cost efficiency. Rediscover them.",
  },
  {
    title: "Protect",
    desc: "It is important to build. It is even more imporant to protect. Safeguard your digital assets.",
  },
];

// {
//     "slug": "",
//     "metaDesc": "",
//     "metaKeyword": "",
//     "image": "",
//     "paragraph": "",
//     "heading": "",
//     "mainHeading": "",
//     "numbers": [
//         {
//             "number": "",
//             "detail": ""
//         },
//     ],
//     "details": {
//         "title": "",
//         "summary": "",
//         "listItems": [
//             "",
//         ]
//     },
//     "points": [
//         {
//             "key": "",
//             "title": "",
//             "text": ""
//         },
//     ],
//     "whyChooseUs": ""
// }
